import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import CategoryGrid from "@/components/CategoryGrid";
import Footer from "@/components/Footer";
import { LazyMount } from "@/components/LazyMount";

// Below-the-fold: defer JS download + execution
const FeaturedArticles = lazy(() => import("@/components/FeaturedArticles"));
const PriceDropsWidget = lazy(() =>
  import("@/components/PriceDropsWidget").then((m) => ({ default: m.PriceDropsWidget }))
);
const InArticleAd = lazy(() =>
  import("@/components/AdSense").then((m) => ({ default: m.InArticleAd }))
);

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <CategoryGrid />
        <LazyMount minHeight={300}>
          <Suspense fallback={<div style={{ minHeight: 300 }} />}>
            <PriceDropsWidget variant="homepage" />
          </Suspense>
        </LazyMount>
        <LazyMount minHeight={500}>
          <Suspense fallback={<div style={{ minHeight: 500 }} />}>
            <FeaturedArticles />
          </Suspense>
        </LazyMount>
        <div className="container mx-auto px-4 max-w-6xl py-6">
          <LazyMount minHeight={250}>
            <Suspense fallback={<div style={{ minHeight: 250 }} />}>
              <InArticleAd />
            </Suspense>
          </LazyMount>
        </div>
      </main>
      <Footer />
      
    </div>
  );
};

export default Index;

